/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideIcon16Solid = forwardRef('DivideIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" }),
        React.createElement("path", { d: "M2.25 8c0-.69.56-1.25 1.25-1.25h9a1.25 1.25 0 1 1 0 2.5h-9c-.69 0-1.25-.56-1.25-1.25Z" }),
        React.createElement("path", { d: "M8 13.998A1.5 1.5 0 1 0 8 11a1.5 1.5 0 0 0 0 2.998Z" })));
});
